<template>
  <div class="contact-page" v-loading="infoLoading">
    <div class="sec-hd">
      <h2 class="title">联系人</h2>
      <div class="btn-group">
        <el-button type="primary" size="medium" @click="showDialog=true">添加联系人</el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      border
      class="table"
      header-row-class-name="head"
    >
      <el-table-column
        prop="name"
        label="姓名"
        width="180">
      </el-table-column>
      <el-table-column
        prop="dept"
        label="部门">
      </el-table-column>
      <el-table-column
        prop="dutyName"
        label="职务">
      </el-table-column>
      <el-table-column
        prop="phone"
        label="联系方式">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="100">
        <template slot-scope="scope">
          <el-button @click="edit(scope.row)" type="primary" size="small">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="新增联系人"
      :visible.sync="showDialog"
      width="600px">
      <el-form ref="form" label-width="100px" :rules="rules" :model="form">
        <el-form-item label="姓名：" prop="name">
          <el-input v-model.trim="form.name"></el-input>
        </el-form-item>
        <el-form-item label="联系方式：" prop="phone">
          <el-input v-model.trim="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="部门" prop="dept">
          <el-input v-model.trim="form.dept"></el-input>
        </el-form-item>
        <el-form-item label="职务：" prop="duty">
          <el-select v-model="form.duty" value-key="key" style="width: 100%;">
            <el-option
              v-for="(item,index) in postList"
              :key="index"
              :label="item.value"
              :value="item.key "
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input v-model.trim="form.remark" type="textarea" resize="none"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  linkmanList,
  linkmanAdd,
  linkmanUpdate
} from '@/service/customerInformation.js';
import {
  linkManPost
} from '@/service/area.js';
import {
  validContact
} from '@/utils/formRule.js';
export default {
  data(){
    return{
      infoLoading: false,
      tableData:[],
      showDialog:false,
      form:{
        dept:'',
        duty:'',
        name:'',
        phone:'',
        remark:'',
      },
      editId:0,
      postList:[],//职位列表
      rules:{
        name:[{required: true, message: '请输入姓名', trigger: 'blur'}],
        phone:[{required: true, message: '请输入联系方式', trigger: 'blur'},
        {validator:validContact, trigger: 'blur'}],
      }
    }
  },
  created() {
    this.pageInit();
  },
  mounted() {
    this.loadList();
  },
  methods: {
    pageInit(){
      //获取职位列表
      linkManPost().then(r=>{
        if(r.Result==1){
          this.postList=r.Data ||[];
        }
      })
    },
    //加载列表
    loadList(){
      this.infoLoading = true
      let custId = Number(this.$route.query.custId);
      let data = {
        custId:custId
      }
      linkmanList(data).then(r=>{
        this.infoLoading = false
        if(r.Result==1){
          this.tableData=r.Data.datas ||[];
        }
      })
    },
    // 打开编辑
    edit(data){
      console.log(data);
      this.form={
        dept:data.dept||'',
        duty:data.duty||'',
        name:data.name||'',
        phone:data.phone||'',
        remark:data.remark||'',
      }
      this.editId=data.pkid;
      this.showDialog = true;
    },
    //提交
    save(){
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params={
            ...this.form,
          }
          params['custId'] = Number(this.$route.query.custId);
          if(this.editId){
            params['pkid']=this.editId;
            linkmanUpdate(params).then(r=>{
              if(r.Result==1){
                this.editId=0;
                this.$refs.form.resetFields();
                this.loadList();
                this.showDialog = false;
              }else{
                this.$message.error(r.Message);
              }
            })
          }else{
            linkmanAdd(params).then(r=>{
              if(r.Result==1){
                this.editId=0;
                this.$refs.form.resetFields();
                this.loadList();
                this.showDialog = false
              }else{
                this.$message.error(r.Message);
              }
            })
          }
        }
      });
    },
    //取消
    cancel(){
      this.$refs.form.resetFields();
      this.showDialog = false;
    }
  },
}
</script>
<style lang="scss">
.contact-page{
  .sec-hd{
		overflow: hidden;
		margin-bottom: 20px;
		.title{
			font-size: 18px;
			color: #333;
			line-height: 40px;
			font-weight: bold;
      float: left;
		}
    .btn-group{
      float: right;
    }
	}
  .table{
    width: 100%;
    .head th{
      background-color: #f9f9f9;
    }
  }
}
</style>